<template>
  <Alert :variant="variant" @click="emit('close')">
    <TriangleAlert v-if="variant === 'destructive'" class="h-4 w-4" />
    <Rocket v-else-if="variant === 'success'" class="h-4 w-4" />
    <AlertTitle class="mb-1 font-semibold">{{ title }}</AlertTitle>
    <AlertDescription class="first-letter:uppercase">
      {{ message }}
    </AlertDescription>
  </Alert>
</template>

<script setup lang="ts">
import { AlertTitle, AlertDescription, Alert, type AlertVariants } from '@ui/alert';
import { TriangleAlert, Rocket } from 'lucide-vue-next';

interface InfoBarProps {
  variant?: AlertVariants['variant'];
  title: string;
  message: string;
}

const emit = defineEmits<{
  close: [];
}>();

withDefaults(defineProps<InfoBarProps>(), {
  variant: 'default',
});
</script>
